export const GetValueFromHash = (hash,key) => {
    let matches = hash.match(new RegExp(key+'=([^&]*)')); //first one uses #, second and later uses &
    return matches ? matches[1] : null;
}

